/* global Provider */
import React, { Component } from 'react';
import { LineChart, XAxis, YAxis, Tooltip, CartesianGrid, Legend, Line, ResponsiveContainer, ReferenceLine, ReferenceArea, Label, Scatter, Cell } from 'recharts';
import Num from '../util/NumberUtil.js';
import Colors from '../util/Colors.js';
import _ from 'underscore';
var d3 = require('d3-shape');

class GlideChart extends Component {
    constructor(props) {
        super(props);
        
        this.colors = new Colors();
        this.state = {
            lineProps:{}
        }
    }

    getLabel() {
        return <Label>Some Text</Label>
    }

    selectPath(event) {
        if(this.props.showOptimal){
            let optimalList = Provider.getFinalOptimal()
            if(optimalList==null){
                optimalList={}
            }
            
            if(optimalList[event.value]==true){
                delete optimalList[event.value]
            }else{
                optimalList[event.value]=true
            }
            optimalList['Glide Optimal']=false
            Provider.setFinalOptimal(optimalList)
        }
    }

    render() {
        let {lineProps} = this.state;

        let fundsAlpha = _.sortBy(Provider.getFunds(), (fund) => {
            return fund.label;
        });
        if (fundsAlpha.length > 0 && !this.props.showOptimal) {
            fundsAlpha.push({ id: 'Industry Max', display: 'Industry Aggressive', color: '#aaaaaa', dash: "5 5" });
            fundsAlpha.push({ id: 'Industry Min', display: 'Industry Conservative', color: '#cccccc', dash: "5 5" });
            
        }else if(fundsAlpha.length > 0 && this.props.showOptimal) {
            fundsAlpha.push({ id: 'Glide Optimal', display: 'Glide Optimal', color: '#ff0000', dash: "5 5" });
        }

        let glides = Provider.getGlides();
        let providerState = Provider.state;
        if (providerState.responses != null && this.props.showOptimal) {
            if (providerState.responses['14'] != null && providerState.responses['19'] != null) {
                if (providerState.responses['14'].selected.id === '1' && providerState.responses['19'].selected.id === '1') {
                    glides['Glide Optimal'] = Provider.getOptimals()['HiSaver_Aggr']
                } else if (providerState.responses['14'].selected.id === '1' && providerState.responses['19'].selected.id === '2') {
                    glides['Glide Optimal'] = Provider.getOptimals()['HiSaver_Avg']
                } else if (providerState.responses['14'].selected.id === '1' && providerState.responses['19'].selected.id === '3') {
                    glides['Glide Optimal'] = Provider.getOptimals()['HiSaver_Cons']
                } else if (providerState.responses['14'].selected.id === '2' && providerState.responses['19'].selected.id === '1') {
                    glides['Glide Optimal'] = Provider.getOptimals()['TypSaver_Aggr']
                } else if (providerState.responses['14'].selected.id === '2' && providerState.responses['19'].selected.id === '2') {
                    glides['Glide Optimal'] = Provider.getOptimals()['TypSaver_Avg']
                } else if (providerState.responses['14'].selected.id === '2' && providerState.responses['19'].selected.id === '3') {
                    glides['Glide Optimal'] = Provider.getOptimals()['TypSaver_Cons']
                } else if (providerState.responses['14'].selected.id === '3' && providerState.responses['19'].selected.id === '1') {
                    glides['Glide Optimal'] = Provider.getOptimals()['LowSaver_Aggr']
                } else if (providerState.responses['14'].selected.id === '3' && providerState.responses['19'].selected.id === '2') {
                    glides['Glide Optimal'] = Provider.getOptimals()['LowSaver_Avg']
                } else if (providerState.responses['14'].selected.id === '3' && providerState.responses['19'].selected.id === '3') {
                    glides['Glide Optimal'] = Provider.getOptimals()['LowSaver_Cons']
                }
            }
        }
        let groups = _.map(fundsAlpha, (fund, index) => {
            let raw = glides[fund.id];
            let data = _.map(raw, (value, index) => {
                return { category: index, value: parseFloat(value, 10) };
            });
            return { id: fund.id, display: fund.display, data: data, color: fund.color || this.colors.get(index), dash: fund.dash || null };
        });

        let finalOptimal = Provider.getFinalOptimal()

        let curveFunction01 = d3.curveBasis;
        //let curveFunction01 = d3.curveMonotoneX;
        //let curveFunction01 = d3.curveLinear;

        if (groups.length === 0) {
            return (
                <div className="chart-placeholder">
                    Add Funds to Compare Equity Allocations
                </div>
            )
        } else {
            return (
                <ResponsiveContainer height={580} width="90%" id={this.props.id || 'glideChart'}>
                    <LineChart margin={{ top: 15, right: 20, left: 0, bottom: 25 }}>
                        <XAxis
                            label={{ value: "Years to Retirement", position: 'bottom', offset: 0 }}
                            padding={{ left: 10, right: 10 }} dataKey="category" type="category" allowDuplicatedCategory={false}
                            ticks={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]}
                            tickFormatter={(value) => {
                                return 45 - (value * 5);
                            }} />
                        <YAxis
                            label={{ value: "Equity Allocation (%)", position: 'inside', offset: 0, angle: -90 }}
                            minTickGap={0} scale="linear" dataKey="value"
                            ticks={[0, .10, .20, .30, .40, .50, .60, .70, .80, .90, 1]}
                            tickFormatter={(value) => {
                                return value * 100;
                            }} />
                        <CartesianGrid vertical={false} />
                        <Tooltip isAnimationActive={false} labelFormatter={(value) => {
                            let newValue = (45 - (value * 5));
                            let yrs = (Math.abs(newValue) === 1 ? ' Year' : ' Years');
                            if (newValue >= 0) return newValue + yrs + ' to Retirement';
                            if (newValue < 0) return Math.abs(newValue) + yrs + ' After Retirement';
                        }} formatter={(value) => {
                            return Num.toPercent(value);
                        }} />
                        <Legend margin={{ top: 100 }} onClick={(e)=>this.selectPath(e)} />
                        <ReferenceLine x={9} stroke="#2b5592">
                            <Label value="Target Retirement Date" offset={10} position="insideTopLeft" />
                        </ReferenceLine>
                        <ReferenceArea x1={6} x2={9} y1={1} y2={1.1} stroke="gray" alwaysShow strokeOpacity={0.3}>
                            <Label value="Early Retirement Zone" offset={10} position="insideTopLeft" />
                        </ReferenceArea>
                        {groups.map(fund => (
                            <Line dataKey="value"
                                isAnimationActive={false}
                                data={fund.data}
                                name={fund.display}
                                key={fund.id}
                                stroke={fund.color}
                                strokeWidth={2} dot={false}
                                strokeDasharray={fund.dash} 
                                type={curveFunction01}
                                hide = {this.props.showOptimal?(finalOptimal!=null?finalOptimal[fund.display]==true:false):false}
                                />
                                
                        ))}
                        <Scatter><Cell/></Scatter>
                    </LineChart>
                </ResponsiveContainer>
            );
        }
    }
}

export default GlideChart;